import { useTranslation } from 'next-i18next'
import { useContext, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { Button } from 'components/common/Button'
import { ButtonVariant } from 'components/common/Button/ButtonVariant'
import { Loader } from 'components/common/Loader'
import { TextInput } from 'components/common/TextInput'
import { apiClient } from 'services/api/client'
import { AuthModalContext } from './AuthModalContext'
import { ForgotPasswordFormValues } from './ForgotPasswordFormValues'
export const ForgotPasswordForm = () => {
  const {
    modalParams: { redirectUrl },
    setModalParams
  } = useContext(AuthModalContext)
  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = async ({ email }: ForgotPasswordFormValues) => {
    setIsLoading(true)
    await apiClient.post<ForgotPasswordFormValues>(
      'auth/request-reset-password',
      {
        email,
        redirectUrl
      }
    )
    setIsLoading(false)
    setModalParams({
      state: 'FORGOT_PASSWORD_SUCCESS',
      redirectUrl,
      email
    })
  }

  const {
    handleSubmit,
    formState: { errors },
    register
  } = useFormContext<ForgotPasswordFormValues>()
  const { t } = useTranslation('authentication')

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      style={{
        width: '100%'
      }}
    >
      <TextInput
        fullSize
        inputProps={{
          ...register('email'),
          autoComplete: 'email',
          required: true
        }}
        inputLabel={t('login.form.email.label')}
        errorMessage={errors.email?.message}
      />
      <Button
        variant={ButtonVariant.Primary}
        fullWidth
        label={t('forgotPassword.button.submit')}
        leftIcon={isLoading ? <Loader /> : undefined}
        disabled={isLoading}
        type="submit"
      />
    </form>
  )
}
